document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".tab-btn");
    const tabContents = document.querySelectorAll(".tab-content");
    const headers = document.querySelectorAll(".tab-header");

    tabButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const targetId = button.getAttribute("data-target");

            tabButtons.forEach((btn) => btn.classList.remove("active"));
            tabContents.forEach((tab) => tab.classList.remove("active"));

            button.classList.add("active");
            document.getElementById(targetId).classList.add("active");
        });
    });

    headers.forEach((header) => {
        header.addEventListener("click", () => {
            const parentTab = header.parentElement;
            const isActive = parentTab.classList.contains("active");

            tabContents.forEach((tab) => tab.classList.remove("active"));

            if (!isActive) {
                parentTab.classList.add("active");
            }
        });
    });
});
